import type { FC, ReactNode } from 'react';

import categoryBg from '@wwe-portal/ui/assets/images/offer/offer-category-bg.webp';

import { CategoryTitleTooltip } from './category-title-tooltip';

interface OfferCategoryProps {
  backgroundImage?: ReactNode;
  title: ReactNode;
  tooltipTitle?: ReactNode;
  description?: ReactNode;
  id?: string;
}
export const OfferCategory: FC<OfferCategoryProps> = ({
  backgroundImage,
  title,
  tooltipTitle,
  description,
  id,
}) => {
  return (
    <div data-category={id}>
      <div className="relative h-[35px] w-full">
        <div className="absolute inset-0">
          {backgroundImage || (
            <img
              alt="category background"
              className="size-full object-fill"
              src={categoryBg}
            />
          )}
        </div>
        <div className="absolute inset-0 bottom-0.5 flex items-center justify-center">
          <span className="inline truncate stroke-2 pl-4 pr-8 text-base font-bold text-white">
            {title}
          </span>
          {tooltipTitle && (
            <div className="absolute right-2">
              <CategoryTitleTooltip tooltipContent={tooltipTitle} />
            </div>
          )}
        </div>
      </div>
      {description && (
        <div className="text-text300 mt-5 text-sm font-semibold">
          {description}
        </div>
      )}
    </div>
  );
};
